module.exports = __webpack_public_path__ + "img/9788947528917.26fe75c8.jpg";